import React, { useEffect, useState, useContext, useMemo, useRef } from 'react'
import "../css/ApplyLeave.css"
import "../css/commonStyles.css"
import ms from "ms";
import ApiClient from "../ApiClient";
import moment from 'moment';
import CentralizedTable from '../components/CentralizedTable';
import { useSelector } from "react-redux"
import { selectUser } from "../stores/userSlice";
import { selectIsApiLoading } from "../stores/loadingSlice";
import { FormCardSkeleton, ListCardSkeleton } from "../components/PageSkeletonLoaders";
import { notify } from "../utils/ToastUtils";
import "../css/leave.css"
import { formatValue } from 'src/Utils';
import { AppContext } from "src/stores/ContextProvider";
import Tooltip from '@mui/material/Tooltip';
import ActionConfirmModal from '../components/ActionConfirmModal';
import UserAvatar from '../components/UserAvatar';
import { CalendarDays, FileText, Users, Pencil, Ban, Trash2, Undo2, CheckCircle2, Info, Check, Clock, X } from 'lucide-react';
import { TextField, Select, MenuItem, Pagination } from '@mui/material';
import { useNavigate } from 'react-router-dom';

function ApplyLeave(props) {
    const topRef = useRef(null);
    const navigate = useNavigate();
    const user = useSelector(selectUser)
    const [flag, setFlag] = useState(false);
    const [leaves, setLeaves] = useState([]);
    const [holidays, setHolidays] = useState([]);
    const { officeHolidays } = useContext(AppContext);
    const [isDisabled, setIsDisabled] = useState(false);
    const isApiLoading = useSelector(selectIsApiLoading);
    const [minDate, setMinDate] = useState(null)
    const [aprMax, setAprMax] = useState(null)
    const currentYear = moment().format("YYYY");
    const [daysDisabled, setDaysDisabled] = useState(true);
    const [page, setPage] = useState(1);
    const itemsPerPage = 5;

    const getCycleBounds = () => {
        const today = moment();
        const day = today.date();
        let start, end;
        if (day >= 20) {
            start = today.clone().date(20);
            end = today.clone().add(1, "month").date(19);
        } else {
            start = today.clone().subtract(1, "month").date(20);
            end = today.clone().date(19);
        }
        return { startStr: start.format("MMM DD"), endStr: end.format("MMM DD") };
    };
    const cycle = getCycleBounds();
    const [balance, setBalance] = useState([]);
    const [editLeave, setEditLeave] = useState({});
    
    // Status table state
    const [rows, setRows] = useState([])
    const [confirmModal, setConfirmModal] = useState({
        isOpen: false, actionType: null, rowData: null, title: '', message: '', loading: false
    });

    const leaveOptions = [
        { value: "Personal Leave", label: "Personal Leave" },
        { value: "Sick/Medical Leave", label: "Sick/Medical Leave" },
        { value: "Emergency Leave", label: "Emergency Leave" },
        { value: "Maternity Leave", label: "Maternity Leave" },
        { value: "Paternity Leave", label: "Paternity Leave" },
        { value: "Bereavement Leave", label: "Bereavement Leave" },
        { value: "Special Leave", label: "Special Leaves - Birthday/ Marriage Anniversary" }
    ];
    const initialState = { leaveType: '', startDt: '', endDt: '', reason: '' }
    const [state, setState] = useState(initialState)
    const [FullOrHalf, setFullOrHalf] = useState(false)
    const [formError, setFormError] = useState("");

    const hasError = (field) => {
        if (!formError) return false;
        if (formError === "All fields are required" && !state[field]) return true;
        if (field === 'startDt' && (formError.includes("weekend") || formError.includes("Saturday") || formError.includes("holiday") || formError.includes("lesser than End Date"))) return true;
        if (field === 'endDt' && (formError.includes("Saturday") || formError.includes("lesser than End Date"))) return true;
        return false;
    };
    
    useEffect(() => {
        if (state.startDt == state.endDt && state.startDt !== "") {
            setDaysDisabled(false)
        } else {
            setFullOrHalf(false);
            setDaysDisabled(true)
        }
    }, [state])

    function handleChange(evt) {
        const { name, value } = evt.target;
        if (name === "startDt" || name === "endDt") {
            if (value) {
                const day = new Date(value).getUTCDay();
                if (day === 0 || day === 6) {
                    setState((prev) => ({ ...prev, [name]: "" }));
                    setFormError("Saturdays and Sundays are not allowed");
                    return; 
                }
            }
        }
        
        setState((prev) => {
            const newState = { ...prev, [name]: value };
            
            setFormError((prevError) => {
                if (prevError === "All fields are required") {
                    if (newState.leaveType && newState.startDt && newState.endDt && newState.reason) {
                        return "";
                    }
                    return prevError;
                }
                
                if (name === 'startDt' || name === 'endDt') {
                    if (prevError.includes("Saturday") || prevError.includes("weekend") || prevError.includes("lesser than End Date") || prevError.includes("holiday")) {
                        return "";
                    }
                } else if (prevError && prevError !== "All fields are required" && !prevError.includes("Saturday") && !prevError.includes("weekend") && !prevError.includes("lesser than End Date") && !prevError.includes("holiday")) {
                    return "";
                }
                return prevError;
            });
            
            return newState;
        });
    }

    const handleFullOrHalf = (e) => {
        if (daysDisabled) {
            notify.warning("Half day leave is only available for a single day");
            return;
        }
        setFullOrHalf(e.target.checked)
    }

    const isInArray = (value) => {
        return (officeHolidays.find(item => { return item === value }) || []).length > 0;
    }

    const findNoOfDays = (sDate, eDate) => {
        let startDate = new Date(sDate);
        let endDate = new Date(eDate);
        startDate = new Date(Date.UTC(startDate.getUTCFullYear(), startDate.getUTCMonth(), startDate.getUTCDate()));
        endDate = new Date(Date.UTC(endDate.getUTCFullYear(), endDate.getUTCMonth(), endDate.getUTCDate()));
        endDate.setUTCDate(endDate.getUTCDate() + 1);
        let daysCount = 0;
        while (startDate < endDate) {
            const day = startDate.getUTCDay(); 
            if (day !== 0 && day !== 6) {
                if (!isInArray(moment.utc(startDate).format("YYYY-MM-DD"))) {
                    daysCount++;
                }
            }
            startDate.setUTCDate(startDate.getUTCDate() + 1);
        }
        return daysCount;
    };

    const requestLeave = async () => {
        setIsDisabled(true);
        setFormError("");
        if (state.leaveType && state.startDt && state.endDt && state.reason) {
            if (new Date(state.startDt) <= new Date(state.endDt)) {
                let noOfDays = "";
                if (state.startDt === state.endDt) {
                    const day = new Date(state.startDt).getUTCDay(); 
                    if (day === 0 || day === 6) {
                        setFormError("Selected date falls on a weekend (Sat/Sun)");
                        setIsDisabled(false);
                        return;
                    }
                    if (isInArray(state.startDt)) {
                        setFormError("Selected date is an office holiday");
                        setIsDisabled(false);
                        return;
                    }
                    noOfDays = FullOrHalf ? 0.5 : 1;
                } else {
                    noOfDays = findNoOfDays(state.startDt, state.endDt);                
                }
                try {
                    const { data } = await ApiClient.post(`${process.env.REACT_APP_BASE_URL}/leave/applyLeave`, {
                        code: user.emp_code,
                        name: user.name,
                        mail: user.mail,
                        type: state.leaveType,
                        noOfDays: noOfDays,
                        startDt: state.startDt,
                        endDt: state.endDt,
                        reason: state.reason,
                        requestType: editLeave.REQUEST_ID ? "edit" : "",
                        requestId: editLeave.REQUEST_ID
                    }, { headers: { skipLoader: true } });
                    setIsDisabled(false);
                    notify.success(editLeave.REQUEST_ID ? "Leave request updated successfully" : "Leave applied successfully", { autoClose: 3000 });
                    setState(initialState);
                    upcomingLeaves();
                    availableLeaves();
                    getRequestStatus();
                } catch (error) {
                    console.log(error);
                    let errmsg = (error?.response) ? (error?.response?.data?.message ? error?.response?.data?.message : `${error?.response?.status} - ${error?.response?.statusText}`) : "Something went wrong. Please try again later";
                    setFormError(errmsg);
                    setIsDisabled(false);
                }
            } else {
                setFormError("Start Date should be lesser than End Date");
                setIsDisabled(false);
            }
        } else {
            setFormError("All fields are required");
            setIsDisabled(false);
        }
    };

    const upcomingLeaves = async () => {
        try {
            const { data } = await ApiClient.get(`${process.env.REACT_APP_BASE_URL}/leave/upComingLeaves`)
            let sortedData = data.sort(function (a, b) { return new Date(a["START_DATE"]) - new Date(b["START_DATE"]); });
            setLeaves(sortedData)
        } catch (error) {
            console.log(error)
        }
    }

    const initLeaveData = (leave) => {
        setEditLeave(leave);
        let leaveInitial = {
            leaveType: leave?.LEAVE_TYPE,
            startDt: moment(leave.START_DATE).format('YYYY-MM-DD'),
            endDt: moment(leave.END_DATE).format('YYYY-MM-DD'),
            reason: leave?.LEAVE_REASON
        }
        if (leave?.NO_OF_DAYS == 0.5) setFullOrHalf(true)
        setState(leaveInitial)
        if (topRef.current) {
            topRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    }

    const initDateRange = () => {
        if (state.startDt) {
            const minsec = ms('0d');
            const min_date = new Date(new Date(state.startDt) - minsec);
            setMinDate(moment(min_date).format('YYYY-MM-DD'));
        } else {
            setMinDate('');
        }
        const nextYear = moment().add(1, 'year').format("YYYY");
        setAprMax(moment(`03/31/${nextYear}`, "MM/DD/YYYY").format('YYYY-MM-DD'));
    }

    const availableLeaves = async () => {
        try {
            const { data } = await ApiClient.get(`${process.env.REACT_APP_BASE_URL}/leave/LeaveBalance`)
            setBalance(data)
        } catch (err) {
            console.log(err)
        }
    }

    useEffect(() => {
        upcomingLeaves();
    }, []);

    useEffect(() => {
        if (user && user.emp_code) {
            availableLeaves();
        }
    }, [user]);

    useEffect(() => {
        if (props.leave && Object.keys(props.leave).length > 0) {
            initLeaveData(props.leave)
        }
    }, [props.leave])

    useEffect(() => {
        initDateRange();
    }, [state.startDt]);


    // Request Status Logic
    const isPreviousFinancialYear = (leaveDate) => {
        const today = moment();
        const currentMonth = today.month(); 
        const currentYear = today.year();
        let currentFinancialYearStart;
        if (currentMonth >= 3) { 
            currentFinancialYearStart = moment([currentYear, 3, 1]); 
        } else { 
            currentFinancialYearStart = moment([currentYear - 1, 3, 1]); 
        }
        return moment(leaveDate).isBefore(currentFinancialYearStart);
    };

    const openConfirmModal = (actionType, rowData, title, message) => {
        setConfirmModal({ isOpen: true, actionType, rowData, title, message, loading: false });
    };

    const closeConfirmModal = () => {
        setConfirmModal({ isOpen: false, actionType: null, rowData: null, title: '', message: '', loading: false });
    };

    const handleConfirm = async () => {
        const { actionType, rowData } = confirmModal;
        setConfirmModal(prev => ({ ...prev, loading: true }));
        if (actionType === 'deleteLeave') {
            await handleLeaveDelete(rowData);
        } else if (actionType === 'undoLeave') {
            await handelDeleteLeaveUndo(rowData);
        }
        closeConfirmModal();
    };

    const statusColumns = useMemo(() => [{
        headerName: "Leave Type", field: "LEAVE_TYPE", sortable: true, width: 180
    }, {
        headerName: "Start Date", field: "START_DATE", sortable: true, width: 120,
        valueGetter: (params) => moment(params.row?.START_DATE).format("DD-MMM-YYYY")
    }, {
        headerName: "End Date", field: "END_DATE", sortable: true, width: 120,
        valueGetter: (params) => moment(params.row?.END_DATE).format("DD-MMM-YYYY")
    }, {
        headerName: "#Days", field: "NO_OF_DAYS", sortable: true, width: 80
    }, {
        headerName: "Reason", field: "LEAVE_REASON", sortable: true, width: 200,
        renderCell: (params) => (
            <Tooltip title={params?.row?.LEAVE_REASON || ""} arrow placement="top">
                <div className="truncate block" style={{ maxWidth: '160px' }}>
                    {params?.row?.LEAVE_REASON}
                </div>
            </Tooltip>
        )
    }, {
        headerName: "Status", field: "LEAVE_STATUS", sortable: true, width: 120,
        renderCell: (params) => {
            const status = params?.row?.LEAVE_STATUS || "Pending";
            const colorClass = status === "Accepted" ? "bg-emerald-100 text-emerald-700 border-emerald-200" : status === "Pending" ? "bg-amber-100 text-amber-700 border-amber-200" : "bg-rose-100 text-rose-700 border-rose-200";
            return <div className="flex items-center h-full"><span className={`px-2.5 py-1 rounded-full text-[11px] font-bold border ${colorClass}`}>{status}</span></div>;
        }
    }, {
        headerName: "Action", field: "Action", sortable: false, width: 100, filterable: false,
        renderCell: (params) => (
        <div className="flex items-center h-full">
            {/* Fixed space for Edit */}
            <div className="w-8 flex justify-center">
            {params.row.LEAVE_STATUS !== "Accepted" && (
                <Tooltip title="Edit">
                <span onClick={() => initLeaveData(params.row)}>
                    <Pencil
                    size={16}
                    color="#2563eb"
                    className="cursor-pointer hover:scale-110 transition-transform"
                    />
                </span>
                </Tooltip>
            )}
            </div>

            {/* Fixed space for Delete / Undo */}
            <div className="w-8 flex justify-center">
            {params.row.REQUEST_TYPE !== 1 ? (
                params.row.DELETE_STATUS === "Undo" ||
                params.row.DELETE_STATUS === "Reject" ? (
                <Ban size={16} className="text-gray-400" />
                ) : isPreviousFinancialYear(params.row.START_DATE) ? (
                <Tooltip
                    title="Previous year leave records cannot be deleted after cycle processing."
                >
                    <span>
                    <Trash2
                        size={16}
                        className="text-gray-400 cursor-not-allowed"
                    />
                    </span>
                </Tooltip>
                ) : (
                <Tooltip title="Delete">
                    <span
                    onClick={() => {
                        const start = moment(params.row.START_DATE).format("DD-MMM-YYYY");
                        const end = moment(params.row.END_DATE).format("DD-MMM-YYYY");
                        openConfirmModal(
                        "deleteLeave",
                        params.row,
                        "Delete Leave",
                        `Are you sure you want to delete this leave request (${start} to ${end})?\nThis action cannot be undone.`
                        );
                    }}
                    >
                    <Trash2
                        size={16}
                        className="text-red-500 cursor-pointer hover:scale-110 transition-transform"
                    />
                    </span>
                </Tooltip>
                )
            ) : (
                <Tooltip title="Undo">
                <span
                    onClick={() => {
                    const start = moment(params.row.START_DATE).format("DD-MMM-YYYY");
                    const end = moment(params.row.END_DATE).format("DD-MMM-YYYY");
                    openConfirmModal(
                        "undoLeave",
                        params.row,
                        "Revert",
                        `Are you sure you want to revert the cancellation of this leave request (${start} to ${end})?\nThis action cannot be undone.`
                    );
                    }}
                >
                    <Undo2
                    size={16}
                    className="text-blue-600 cursor-pointer hover:scale-110 transition-transform"
                    />
                </span>
                </Tooltip>
            )}
            </div>
        </div>
        )
    }, {
        headerName: "Raised By", field: "REQUEST_RAISED_BY", sortable: true, width: 150,
        renderCell: (params) => (<span>{params?.row?.REQUEST_RAISED_BY || 'Self'}</span>)
    }], []);

    const getRequestStatus = async () => {
        try {
            const { data } = await ApiClient.get(`${process.env.REACT_APP_BASE_URL}/leave/requestStatus`)
            setRows(data)
        } catch (error) {
            console.log(error)
        }
    }

    const handleLeaveDelete = async (row) => {
        if (new Date(row.START_DATE) > new Date()) {
            try {
                await ApiClient.delete(`${process.env.REACT_APP_BASE_URL}/leave/deleteLeave`, { data: { data: row }, headers: { skipLoader: true } })
                notify.success("Leave Deleted Successfully");
                getRequestStatus();
                upcomingLeaves();
                availableLeaves();
            } catch (error) {
                notify.error("Something went wrong. Please try again later")
            }
        } else {
            try {
                await ApiClient.put(`${process.env.REACT_APP_BASE_URL}/leave/rejectDeleteLeave`, { REQUEST_ID: row.REQUEST_ID, STATUS: "Request" }, { headers: { skipLoader: true } })
                notify.success("Submitted For Manager Approval");
                getRequestStatus();
                upcomingLeaves();
                availableLeaves();
            } catch (error) {
                notify.error("Something went wrong. Please try again later")
            }
        }
    }

    const handelDeleteLeaveUndo = async (row) => {
        try {
            await ApiClient.put(`${process.env.REACT_APP_BASE_URL}/leave/rejectDeleteLeave`, { REQUEST_ID: row.REQUEST_ID, STATUS: "Undo" }, { headers: { skipLoader: true } })
            notify.success("Leave cancellation request revoked");
            getRequestStatus();
            upcomingLeaves();
            availableLeaves();
        } catch (error) {
            notify.error("Something went wrong. Please try again later")
        }
    }

    useEffect(() => {
        getRequestStatus();
    }, [])

    return (
        <div className="flex flex-col gap-3" ref={topRef}>
            <div className="grid grid-cols-1 lg:grid-cols-5 gap-3">
                {/* Apply Leave Form Card */}
                {isApiLoading ? <FormCardSkeleton className="lg:col-span-3" /> : (
                <div className="lg:col-span-3 bg-white rounded-2xl shadow-sm border border-slate-200 p-5 flex flex-col relative overflow-hidden group">
                    <div className="flex justify-between items-center border-b border-slate-100 pb-3 mb-3">
                        <div className="flex items-center gap-2 sm:gap-3">
                        <div className="w-9 h-9 rounded-xl bg-orange-50 text-orange-600 flex items-center justify-center shrink-0">
                            <CalendarDays className="w-5 h-5" />
                        </div>
                            <div>
                                <h3 className="text-[15px] font-bold text-slate-800 m-0 leading-tight">{editLeave.REQUEST_ID ? "Edit Leave Request" : "Apply Leave"}</h3>
                                <p className="text-[13px] text-slate-500 m-0 hidden sm:block mt-1">Fill in the details below to submit your leave request</p>
                            </div>
                        </div>
                        <button 
                            onClick={() => navigate('/policies')}
                            className="flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium text-brand-600 bg-white border border-brand-100 rounded-lg hover:bg-brand-50 transition-colors shadow-sm shrink-0 whitespace-nowrap">
                            <FileText className="w-4 h-4 shrink-0" /> <span className="hidden sm:inline">Leave Policy</span><span className="sm:hidden">Policy</span>
                        </button>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-3">
                        <div className="md:col-span-2">
                            <label className="block text-sm font-semibold text-slate-700 mb-1.5">Leave Type <span className="text-red-500">*</span></label>
                            <Select name="leaveType" value={state.leaveType} onChange={handleChange} displayEmpty size="small" fullWidth error={hasError('leaveType')} className={hasError('leaveType') ? '[&_fieldset]:!border-red-500' : ''} sx={{ backgroundColor: '#f8fafc', '& .MuiOutlinedInput-notchedOutline': { borderColor: '#cbd5e1' } }} required>
                                <MenuItem value="" disabled>Select leave type</MenuItem>
                                {leaveOptions.map((leave) => (
                                    <MenuItem key={leave.value} value={leave.value} 
                                        sx={{
                                            fontSize:"14px"
                                        }}>
                                        {leave.label}
                                        </MenuItem>
                                ))}
                            </Select>
                        </div>
                        <div>
                            <label className="block text-sm font-semibold text-slate-700 mb-1.5">Start Date <span className="text-red-500">*</span></label>
                            <TextField type="date" name='startDt' value={state.startDt} onChange={handleChange} inputProps={{ max: aprMax }} size="small" fullWidth error={hasError('startDt')} className={hasError('startDt') ? '[&_fieldset]:!border-red-500' : ''} sx={{ backgroundColor: '#f8fafc', '& .MuiOutlinedInput-notchedOutline': { borderColor: '#cbd5e1' } }} required />
                        </div>
                        <div>
                            <label className="block text-sm font-semibold text-slate-700 mb-1.5">End Date <span className="text-red-500">*</span></label>
                            <TextField type="date" name='endDt' value={state.endDt} onChange={handleChange} inputProps={{ min: minDate, max: aprMax }} size="small" fullWidth error={hasError('endDt')} className={hasError('endDt') ? '[&_fieldset]:!border-red-500' : ''} sx={{ backgroundColor: '#f8fafc', '& .MuiOutlinedInput-notchedOutline': { borderColor: '#cbd5e1' } }} required />
                        </div>
                    </div>

                    <div className="mb-3 flex items-center gap-3">
                        <label className="relative inline-flex items-center cursor-pointer">
                            <input type="checkbox" className="sr-only peer" checked={FullOrHalf} onChange={handleFullOrHalf} />
                            <div className="w-11 h-6 bg-slate-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-slate-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-brand-500"></div>
                        </label>
                        <span className="text-sm font-semibold text-slate-700">Yes, I'm applying for half day leave</span>
                    </div>

                    <div className="mb-3">
                        <label className="block text-sm font-semibold text-slate-700 mb-1.5">Reason for Leave <span className="text-red-500">*</span></label>
                        <TextField multiline rows={3} name="reason" value={state.reason} onChange={handleChange} placeholder="Enter reason for leave..." size="small" fullWidth error={hasError('reason')} className={hasError('reason') ? '[&_fieldset]:!border-red-500' : ''} sx={{ backgroundColor: '#f8fafc', '& .MuiOutlinedInput-notchedOutline': { borderColor: '#cbd5e1' }, '& textarea': { resize: 'none', overflowY: 'auto !important' } }} required />
                    </div>

                    {formError && (
                        <div className="mb-3 p-2 bg-red-50 border border-red-200 text-red-600 text-sm font-medium rounded-lg flex items-center gap-2">
                            <Info className="w-4 h-4 shrink-0" />
                            {formError}
                        </div>
                    )}

                    <div className="flex items-center justify-between mt-0 pt-4 border-t border-slate-100">
                        <div className="text-[12px] font-medium text-slate-500">
                            {balance?.length > 0 && (
                                <>No of days left: <span className="text-brand-600 font-bold">{formatValue(parseFloat(balance?.[0]?.TOTAL_LEAVE_BALANCE || 0))} Days</span></>
                            )}
                        </div>
                        <div className="flex items-center gap-2">
                            {editLeave.REQUEST_ID && (
                                <button type="button" onClick={() => { setEditLeave({}); setState(initialState); }} className="flex items-center gap-2 px-4 py-1.5 bg-white text-slate-700 text-sm rounded-lg hover:bg-slate-50 transition-all font-medium shadow-sm border border-slate-200">
                                    Cancel
                                </button>
                            )}
                            <button type="button" onClick={requestLeave} disabled={isDisabled} className="flex items-center gap-2 px-4 py-1.5 bg-brand-600 text-white text-sm rounded-lg hover:bg-brand-700 transition-all font-medium shadow-sm hover:shadow focus:ring-2 focus:ring-brand-600 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed">
                                {isDisabled && <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>}
                                <span>{isDisabled ? "Loading..." : (editLeave.REQUEST_ID ? "Update Leave" : "Request Leave")}</span>
                            </button>
                        </div>
                    </div>
                </div>
                )}

                {/* Team Members Card */}
                {isApiLoading ? <ListCardSkeleton className="lg:col-span-2" /> : (
                <div className="lg:col-span-2 bg-white rounded-2xl shadow-sm border border-slate-200 p-4 flex flex-col">
                    <div className="flex justify-between items-center mb-4 border-b border-slate-100 pb-4">
                        <div className="flex items-center gap-3">
                          <div className="w-9 h-9 rounded-xl bg-teal-50 text-teal-600 flex items-center justify-center shrink-0">
                                <Users className="w-5 h-5" />
                            </div>
                            <div className="flex flex-col">
                                <h3 className="text-[15px] font-bold text-slate-800 m-0">Upcoming Leaves</h3>
                                <p className="text-[12px] font-medium text-slate-500 m-0 mt-0.5">
                                    View your team's upcoming leaves
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="flex flex-col gap-1 overflow-y-auto pr-2 custom-scrollbar flex-1" style={{ maxHeight: "400px" }}>
                        {leaves.length > 0 ? leaves.slice((page - 1) * itemsPerPage, page * itemsPerPage).map((member, idx) => (
                            <div key={idx} className="flex items-center justify-between py-3 px-2 border-b border-slate-100 hover:bg-slate-50 transition-colors gap-2">
                                <div className="flex items-center gap-3 min-w-0">
                                    <div className="shrink-0">
                                        <UserAvatar name={member.EMP_NAME} imageUrl={member.img_dir ? `${process.env.REACT_APP_PUBLIC_URL}/${member.img_dir}` : null} size={36} />
                                    </div>
                                    <div className="min-w-0">
                                        <Tooltip title={member.EMP_NAME} arrow placement="top">
                                            <h4 className="text-[13px] sm:text-[14px] font-bold text-slate-800 m-0 mb-0.5 truncate">{member.EMP_NAME}</h4>
                                        </Tooltip>
                                   <Tooltip title={
                                        member.START_DATE === member.END_DATE 
                                            ? moment(member.START_DATE).format("DD MMM, YYYY")
                                            : `${moment(member.START_DATE).format("DD MMM")} - ${moment(member.END_DATE).format("DD MMM, YYYY")}`
                                   } arrow placement="top">
                                   <div className="text-[11px] sm:text-[12px] font-medium text-slate-500 truncate mt-0.5">
                                        {member.START_DATE === member.END_DATE 
                                            ? moment(member.START_DATE).format("DD MMM, YYYY")
                                            : `${moment(member.START_DATE).format("DD MMM")} - ${moment(member.END_DATE).format("DD MMM, YYYY")}`
                                        }
                                    </div>
                                    </Tooltip>
                                    </div>
                                </div>
                                <div className="flex flex-col sm:flex-row items-end sm:items-center gap-1.5 sm:gap-4 text-right sm:text-left shrink-0">
                                    <div className={`whitespace-nowrap shrink-0 px-2.5 py-0.5 sm:py-1 rounded-full text-[10px] sm:text-[11px] font-bold sm:w-[75px] text-center ${
                                        member.NO_OF_DAYS === 0.5 
                                            ? 'bg-emerald-50 text-emerald-600 border border-emerald-100'
                                            : 'bg-blue-50 text-blue-600 border border-blue-100'
                                    }`}>
                                        {member.NO_OF_DAYS === 0.5 ? "Half Day" : `${member.NO_OF_DAYS} Day${member.NO_OF_DAYS > 1 ? 's' : ''}`}
                                    </div>
                                    
                                    {user?.is_admin === 'Yes' && (
                                        <div className={`whitespace-nowrap flex items-center justify-center gap-1.5 shrink-0 px-2.5 py-0.5 sm:py-1 rounded-full text-[10px] sm:text-[11px] font-bold border sm:w-[100px] ${
                                            (member.LEAVE_STATUS || member.STATUS)?.toLowerCase() === 'approved' || (member.LEAVE_STATUS || member.STATUS)?.toLowerCase() === 'accepted' ? 'bg-green-50 text-green-700 border-green-200' :
                                            (member.LEAVE_STATUS || member.STATUS)?.toLowerCase() === 'rejected' ? 'bg-red-50 text-red-700 border-red-200' :
                                            'bg-orange-50 text-orange-600 border-orange-200'
                                        }`}>
                                            {((member.LEAVE_STATUS || member.STATUS)?.toLowerCase() === 'approved' || (member.LEAVE_STATUS || member.STATUS)?.toLowerCase() === 'accepted') ? (
                                                <Check className="w-3 h-3" />
                                            ) : (member.LEAVE_STATUS || member.STATUS)?.toLowerCase() === 'rejected' ? (
                                                <X className="w-3 h-3" />
                                            ) : (
                                                <Clock className="w-3 h-3" />
                                            )}
                                            {(member.LEAVE_STATUS || member.STATUS) === 'Approved' ? 'Accepted' : (member.LEAVE_STATUS || member.STATUS) || 'Pending'}
                                        </div>
                                    )}
                                </div>
                            </div>
                        )) : (
                            <div className="h-full flex flex-col sm:flex-row items-center justify-between p-4 bg-slate-50/50 rounded-2xl border border-dashed border-slate-200 mt-2">
                                <div className="flex items-center gap-4">
                                    <div className="w-12 h-12 rounded-full bg-emerald-100 flex items-center justify-center shrink-0">
                                        <CheckCircle2 className="w-6 h-6 text-emerald-600" strokeWidth={2.5} />
                                    </div>
                                    <div>
                                        <p className="text-[14px] font-bold text-slate-800">You're all caught up!</p>
                                        <p className="text-xs font-medium text-slate-500 mt-0.5">No team members on leave.</p>
                                    </div>
                                </div>
                                <div className="hidden sm:flex items-center justify-center pr-4 opacity-60">
                                    <div className="relative">
                                        <Users className="w-10 h-10 text-emerald-400 stroke-[1.5]" />
                                        <div className="absolute top-0 right-0 w-3 h-3 bg-emerald-500 rounded-full border-2 border-white flex items-center justify-center">
                                            <CheckCircle2 className="w-1.5 h-1.5 text-white" strokeWidth={4} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                    {leaves.length > itemsPerPage && (
                        <div className="flex justify-center mt-3 shrink-0">
                            <Pagination 
                                count={Math.ceil(leaves.length / itemsPerPage)} 
                                page={page} 
                                onChange={(e, val) => setPage(val)} 
                                size="small" 
                                sx={{
                                    '& .MuiPaginationItem-root.Mui-selected': {
                                        backgroundColor: '#eff6ff', // tailwind blue-50
                                        color: '#2563eb', // tailwind blue-600
                                        fontWeight: 'bold',
                                        '&:hover': {
                                            backgroundColor: '#dbeafe', // tailwind blue-100
                                        }
                                    }
                                }} 
                            />
                        </div>
                    )}
                </div>
                )}
            </div>

            {/* Leave Request Status Card */}
            <div className="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden">
                <div className="p-0 pt-1">
                    <CentralizedTable
                        getRowId={row => row.REQUEST_ID}
                        rows={rows}
                        columns={statusColumns}
                        isLoading={isApiLoading}
                        autoHeight
                        renderTopToolbarCustomActions={() => (
                            <h3 className="text-[15px] font-bold text-slate-800 m-0">Leave Request Status</h3>
                        )}
                        initialState={{
                            pagination: { paginationModel: { pageSize: 5, page: 0 } },
                            columnPinning: { right: ['Action'] }
                        }}
                        enableColumnPinning={true}
                        muiTableHeadCellProps={({ column }) => ({
                            sx: {
                                boxShadow: 'none !important',
                                '&::before': {
                                    boxShadow: column.id === 'Action' ? '-4px 0 10px rgba(0,0,0,0.05) !important' : 'none !important',
                                }
                            }
                        })}
                        muiTableBodyCellProps={({ cell }) => ({
                            sx: {
                                py: "8px",
                                borderBottom: "1px solid #e2e8f0",
                                px: cell.column.getIndex() === 0 ? '16px' : "3px",
                                overflow: cell.column.id === 'Action' ? 'visible' : 'hidden',
                                textOverflow: cell.column.id === 'Action' ? 'clip' : 'ellipsis',
                                backgroundColor: cell.column.id === 'Action' ? '#fff !important' : 'inherit',
                                boxShadow: 'none !important',
                                '&::before': {
                                    boxShadow: cell.column.id === 'Action' ? '-4px 0 10px rgba(0,0,0,0.05) !important' : 'none !important',
                                }
                            },
                        })}
                        muiTableContainerProps={{
                            sx: {
                                minHeight: "auto",
                                height: 'auto',
                                flex: 1,
                                overflow: 'auto',
                            },
                        }}
                        pageSizeOptions={[5, 10,15]}
                        hideFooterSelectedRowCount
                    />
                </div>
            </div>

            <ActionConfirmModal 
                isOpen={confirmModal.isOpen} 
                onClose={closeConfirmModal} 
                onConfirm={handleConfirm} 
                title={confirmModal.title} 
                message={confirmModal.message} 
                loading={confirmModal.loading} 
            />
        </div>
    )
}

export default ApplyLeave
